import React from 'react';

import { EditOutlined } from '@ant-design/icons';
import ListPageHeader from '@shared/ListPageHeader';
import Can from '@shared/permissions/Can';
import { Descriptions, Button, Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { formatDateTime } from '../../../utils/dateTime';
/**
 * Consumable Show View (Common Component)
 *
 * @param {Object} props
 * @param {Object} props.consumable - Consumable data (loaded by route loader)
 * @param {string} props.role - 'admin' or 'operator'
 */
export default function ConsumableShow({
  consumable,
  role = 'admin'
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!consumable) {
    return (
      <Empty description={t('common.error.no_data')} />
    );
  }

  const basePath = role === 'operator' ? '/operator' : '/admin';
  const breadcrumbItems = role === 'operator'
    ? ['warehouse_settings', 'warehouse_settings.consumables', { label: consumable.name }]
    : ['data', 'data.consumables', { label: consumable.name }];

  const headerActions = consumable.editable && (
    <Can requiredPermission="consumables:write">
      <Button type="primary" icon={<EditOutlined />} onClick={() => navigate(`edit`)}>
        {t('common.button.edit')}
      </Button>
    </Can>
  );

  return (
    <div>
      <ListPageHeader
        basePath={basePath}
        items={breadcrumbItems}
        actions={headerActions}
      />
      <Descriptions bordered column={2}>
        <Descriptions.Item label={t(`models.consumable.name`)}>
          {consumable.name}
        </Descriptions.Item>
        <Descriptions.Item label={t(`models.consumable.barcode`)}>
          {consumable.barcode}
        </Descriptions.Item>
        <Descriptions.Item label={t(`models.consumable.length`)}>
          {consumable.length || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t(`models.consumable.width`)}>
          {consumable.width || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t(`models.consumable.height`)}>
          {consumable.height || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t(`models.consumable.volume`)}>
          {consumable.volume || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={t(`common.created_at`)} span={2}>
          {formatDateTime(consumable.created_at)}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
}
